import Badge from "@common/controls/Badge/component";
import CardList from "@common/controls/Card/List/component";
import { CurrencyFlag } from "@common/controls/Flag/component";
import Hint from "@common/controls/Hint/component";
import { useI18n } from "@common/hooks/i18n";
import { formatMoneyDisplay } from "@common/lib/format";
import { type Account } from "@common/modules/account/types";
import * as React from "react";

export type Currency = {
  label: string;
  currencyCode: string;
};

export type AccountCardListProps = {
  accountStyle?: React.CSSProperties;
  addLabel?: string;
  aspectRatio?: string | number;
  columns?: number;
  currencies: Currency[];
  data: Account.Api.Account[];
  disabledTooltip?: string;
  maxHeight?: string | number;
  onAdd?: (() => void) | null;
  onClick?: (data: Account.Api.Account) => void;
};
export const AccountCardList = (props: AccountCardListProps) => {
  const i18n = useI18n();
  return (
    <CardList
      addLabel={props.addLabel}
      addStyle={props.accountStyle}
      aspectRatio={props.aspectRatio}
      className="account_card_list"
      columns={props.columns ?? 4}
      disabledTooltip={props.disabledTooltip}
      maxHeight={props.maxHeight}
      onAdd={props.onAdd}
    >
      {props.data.map((x) => (
        <div
          key={x.accountId}
          className="data_container"
          onClick={() => props.onClick && props.onClick(x)}
          style={props.accountStyle}
        >
          <div className="header">
            <CurrencyFlag currencyCode={x.currencyCode} size={38} isRound />

            {x.isPreferred && <Badge tooltip={i18n.infoAffiliateCommissionsAccount}>{i18n.commission}</Badge>}
          </div>

          <div className="description">
            <div className="balance">{formatMoneyDisplay(x.balance, x.currencyCode)}</div>
            <Hint className="single-line-ellipsis" hint={x.currencyName} />
          </div>
        </div>
      ))}
    </CardList>
  );
};
